const config = {
  protocol: 'https',
  api_method: 'https',
  api_version: 'v1'
}

switch (process.env.NODE_ENV) {
  case 'development':
    config.protocol = 'http'
    config.api_method = 'http'
    config.api_server = 'localhost:3000'
    break
  case 'testing':
    break
  case 'staging':
    config.protocol = 'https'
    config.api_method = 'https'
    config.api_server = 'staging-api.taira-bestbeat.com'
    break
  case 'production':
    config.protocol = 'https'
    config.api_method = 'https'
    config.api_server = 'api.taira-bestbeat.com'
    break
}

export default config



// WEBPACK FOOTER //
// ./src/store/config.js